import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-document-scanner-config-view',
  standalone: true,
  templateUrl: './document-scanner-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentScannerConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
